import { MinimalPageContentWrapper as MinimalPageContent } from "./MinimalPageContent";

export type PageContentProps = { className?: string };

export function PageContent({ className }: PageContentProps) {
  return <MinimalPageContent className={className} />;
}
